import React from 'react';
import { ButtonProps } from './Types.ts';

const PrimaryButton = ({ visible, disabled, text, onClick }: ButtonProps) => {
  return (
    <>
      {visible && (
        <button className="btn thule-btn-default w-100" onClick={onClick} disabled={disabled}>
          {text}
        </button>
      )}
    </>
  );
};

export default PrimaryButton;
